import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/book/page.tsx");
